import { Scale } from "~/OnboardingApp/components";
import { ClinicRefer } from "~/OnboardingApp/pages/questionPages/ClinicReferPage";
import { CoverageLevel } from "~/OnboardingApp/pages/questionPages/CoveragePage";
import { CurrentClinic } from "~/OnboardingApp/pages/questionPages/CurrentClinicPage";
import { HasHealthConditions } from "~/OnboardingApp/pages/questionPages/HealthConditionsPage/HealthConditionsPage";
import { HowDidYouHear } from "~/OnboardingApp/pages/questionPages/HowDidYouHearPage/HowDidYouHearPage";
import { HasMedicalDiagnosis } from "~/OnboardingApp/pages/questionPages/MedicalDiagnosisPage";
import { Length } from "~/OnboardingApp/utils";
import { PlanType, Provider } from "./types";

const url = "/api/v1/onboarding";

export type Onboarding = {
  acceptedAdditionalTerms: boolean;
  acceptedTerms: boolean;
  biggestChallenge: string;
  bornOn: string;
  chronicConditions: string;
  clinicRefer: ClinicRefer;
  clinicReferName: string;
  clinicSatisfaction: Scale;
  currentClinic: CurrentClinic;
  currentPartnerId: number | null;
  currentProvider: string | null;
  curiousAbout: string[];
  dueDate: string;
  email: string;
  employer: string;
  fertilityCoverage: CoverageLevel;
  fertilityCoverageOther: string;
  firstName: string;
  hasChronicConditions: HasHealthConditions;
  hasMedicalConditions: HasMedicalDiagnosis;
  howAnxious: Scale;
  howDidYouHear: HowDidYouHear;
  howGrateful: Scale;
  howOptimistic: Scale;
  howSupported: Scale;
  initialTreatmentTags: string[];
  international: boolean;
  journeyLooksLike: string[];
  journeyOtherDetails: string;
  upcomingMilestone: string;
  upcomingMilestoneDate: string;
  lastName: string;
  lengthOfTimeTtc: Length;
  onboardingSource: string;
  otherDetails: string;
  // The onboarding question was retired, but the API still serializes these
  // (OnboardingSerializer), so the type must stay aligned with the payload.
  partner: string;
  partnerEmail: string;
  phone: string;
  planType: PlanType;
  pregnancyBackground: string[];
  pregnancyOtherDetails: string;
  providersOtherDetails: string;
  providersSeen: string[];
  providerId: string;
  relevantMedicalConditions: string;
  supportNeeds: string[];
  supportNeedsOtherDetails: string;
  thingsToSupport: string;
  zipCode: string;
  providers: Provider[];
};

interface OnboardingSerializer {
  data: {
    attributes: Onboarding;
  };
}

export type OnboardingIndexResponse = OnboardingSerializer;

export const onboardingIndexQuery = () => ({
  url,
  method: "GET",
});

export type OnboardingUpdateParams = Partial<Onboarding>;
export type OnboardingUpdateResponse = OnboardingIndexResponse;

export const onboardingUpdateQuery = (params: OnboardingUpdateParams) => ({
  url,
  method: "PATCH",
  body: params,
});
